














































































































































































































































import { Component, Watch, PropSync, Prop, Ref, Vue } from "vue-property-decorator";
import store from "@/store";
import moment from "moment";
//  @types
import { VesselEvent } from "@/types/vesselEvent";
import { TrendEventType } from "@/types/trendEventType";

//  @modules
import { getModule } from "vuex-module-decorators";
import VesselEventsModule from "@/store/clients/VesselEvents.module";
import VesselsModule from "@/store/clients/Vessels.module";

const VesselEvents = getModule(VesselEventsModule, store);
const Vessels = getModule(VesselsModule, store);

@Component({})
export default class VesselEventModal extends Vue {
  @Ref("typeSelect") typeSelect!: any;
  @PropSync("value", { required: true, type: Boolean, default: false }) isModalActive!: boolean;
  @Prop({ type: String, default: "463px" }) width!: string;

  //  @Data
  isNewEvent = true;
  isFormValid = true;
  submitting = false;
  dateMenu = false;
  selectedType: TrendEventType | null = null;
  formData: VesselEvent = {
    vesselId: Vessels.currentVessel?.id,
    type: "TrendEvent",
    source: "Office",
    name: "",
    timestamp: moment().format("YYYY-MM-DD"),
  } as VesselEvent;

  nameValidation = {
    required: (value: string) => !!value || "Enter Event Name",
  };

  dateValidation = {
    required: (value: string) => !!value || "Select Event Date",
  };

  typeSelectValidation = {
    required: (value: TrendEventType) => (!!value && !!value.trendEventTypeId) || "Select Event Type",
  };

  //  @Getters
  get ModalType(): any {
    return {
      mode: this.isNewEvent ? "create" : "edit",
      title: this.isNewEvent ? "Create New Event" : "Update Event",
      subtitle: "This event will be created for all long trend charts, and will not be displayed on the onboard software",
      btnText: this.isNewEvent ? "Create New Event" : "Update Event",
    };
  }

  get trendEventTypes(): TrendEventType[] | null {
    return VesselEvents.trendEventTypes;
  }

  get minDate(): string {
    const trendDataMinDate = Vessels.currentVessel?.trendDataMinDate;
    if (trendDataMinDate) {
      return trendDataMinDate;
    }

    const logDataMinDate = Vessels.currentVessel?.logDataMinDate;
    if (logDataMinDate) {
      return logDataMinDate;
    }

    const minDate = new Date();
    minDate.setFullYear(minDate.getFullYear() - 20);
    return minDate.toISOString().substring(0, 10);
  }

  get maxDate(): string {
    return new Date().toISOString().substring(0, 10);
  }

  //reset the inputs when switching between type in case of new event
  @Watch("type")
  onEventTypeChanged(val: string): void {
    if (!this.isNewEvent || !val) return;
    if (val === "InfoEvent") {
      this.formData.typeId = null;
      this.formData.name = "";
    } else if (val === "TrendEvent") {
      this.$nextTick(() => {
        this.typeSelect.reset();
      });
    }
  }

  selectTrendEventType(trendEventType: TrendEventType): void {
    this.formData.typeId = trendEventType.trendEventTypeId;
    this.formData.name = trendEventType.trendEventTypeName;
  }

  open(vesselEvent?: VesselEvent): void {
    this.isModalActive = true;
    if (vesselEvent) this.setFormData(vesselEvent);
  }

  async onSubmit(): Promise<void> {
    this.submitting = true;
    this.isNewEvent ? await VesselEvents.createEvent(this.formData) : await VesselEvents.editEvent(this.formData);
    this.$emit("onSubmit");
    this.submitting = false;
    this.confirm();
  }

  confirm(): void {
    this.isModalActive = false;
    setTimeout(() => {
      this.resetFormData();
    }, 300);
  }

  close(): void {
    this.isModalActive = false;
    setTimeout(() => {
      this.resetFormData();
    }, 100);
  }

  resetFormData(): void {
    this.isNewEvent = true;
    this.isFormValid = true;
    this.formData = {
      vesselId: Vessels.currentVessel?.id,
      type: "TrendEvent",
      source: "Office",
    } as VesselEvent;
    this.selectedType = null;
    this.dateMenu = false;
  }

  setFormData(vesselEvent: VesselEvent): void {
    this.isNewEvent = false;
    this.selectedType = this.trendEventTypes?.find(trendEventType => trendEventType.trendEventTypeName === vesselEvent.name) ?? null;
    this.formData = {
      ...vesselEvent,
      name: vesselEvent.name,
      source: vesselEvent.source ?? "Office",
      timestamp: vesselEvent.timestamp.split("T")[0],
      type: vesselEvent.type,
      vesselId: vesselEvent.vesselId,
      typeId: this.selectedType?.trendEventTypeId,
    };
  }
}
